/**
 * Shared CRC32 helper.
 *
 * Polynomial 0xedb88320, 256-entry lookup table, identical to the
 * implementation that originally lived in public/js/file-transfer/folder-zip.js.
 * Pulled out so disk-image cluster's checksum-streamer.js, ZIP-fallback paths,
 * and any future format that needs CRC32 (PNG/ZIP/GPT/ISO path tables) share
 * one battle-tested copy.
 *
 * Surface: window.__CRC32 = { bytes, blob }
 *   bytes(seed, Uint8Array) → number   — sync, accumulates from a seed
 *   blob(Blob) → Promise<number>       — streams the Blob in 1 MB chunks
 */
(function (w) {
    'use strict';
    if (w.__CRC32 && w.__CRC32.__fromTimbricaShared) return;

    var TABLE = (function () {
        var t = new Uint32Array(256);
        for (var i = 0; i < 256; i++) {
            var c = i;
            for (var j = 0; j < 8; j++) {
                c = (c & 1) ? (0xedb88320 ^ (c >>> 1)) : (c >>> 1);
            }
            t[i] = c >>> 0;
        }
        return t;
    })();

    function bytes(crc, buf) {
        crc = (crc ^ 0xFFFFFFFF) >>> 0;
        for (var i = 0; i < buf.length; i++) {
            crc = (TABLE[(crc ^ buf[i]) & 0xFF] ^ (crc >>> 8)) >>> 0;
        }
        return (crc ^ 0xFFFFFFFF) >>> 0;
    }

    function blob(b) {
        var CHUNK = 1024 * 1024;
        var crc = 0;
        var off = 0;
        function next() {
            if (off >= b.size) return crc >>> 0;
            var end = Math.min(b.size, off + CHUNK);
            return b.slice(off, end).arrayBuffer().then(function (ab) {
                crc = bytes(crc, new Uint8Array(ab));
                off = end;
                return next();
            });
        }
        return Promise.resolve(next());
    }

    w.__CRC32 = {
        bytes: bytes,
        blob: blob,
        TABLE: TABLE,
        __fromTimbricaShared: true
    };
})(window);
